/**
 * 계정정보찾기 페이지
 * FSD: pages/account-recovery/ui
 */

import React, { useCallback, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AccountRecoveryTabs } from "@/features/account-recovery/ui";
import { showAlert } from "@/shared/lib/alert";

export function AccountRecoveryPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [showSuccess, setShowSuccess] = useState(false);

  // URL 쿼리 파라미터에서 모드 읽기 (기본값: "id")
  const initialMode = (searchParams.get("mode") as "id" | "password") || "id";

  const handleSuccess = useCallback(() => {
    // 성공 메시지 표시
    setShowSuccess(true);
    showAlert("계정 정보 조회가 완료되었습니다. 로그인해주세요.");

    // 2초 후 로그인 페이지로 이동
    setTimeout(() => {
      navigate("/login", { replace: true });
    }, 2000);
  }, [navigate]);

  const handleBackClick = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 py-6 md:py-8 lg:py-12">
      <div className="max-w-2xl mx-auto px-4 md:px-6 lg:px-8">
        {/* 헤더 */}
        <div className="mb-6 md:mb-8">
          <button
            onClick={handleBackClick}
            className="text-sm md:text-base text-gray-600 hover:text-gray-900 font-semibold mb-3 md:mb-4 flex items-center gap-2"
          >
            <span>←</span>
            <span>돌아가기</span>
          </button>
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900">
            계정정보찾기
          </h1>
          <p className="mt-2 md:mt-3 text-sm md:text-base text-gray-600">
            아이디나 비밀번호를 잊으셨나요?
            <br className="hidden md:block" />
            아래에서 계정 정보를 찾을 수 있습니다.
          </p>
        </div>

        {/* 컨텐츠 */}
        <div className="bg-white rounded-lg shadow-sm p-6 md:p-8">
          <AccountRecoveryTabs
            onSuccess={handleSuccess}
            initialMode={initialMode}
          />
        </div>

        {/* 하단 정보 */}
        <div className="mt-6 md:mt-8 text-center">
          <p className="text-xs md:text-sm text-gray-600">
            계정이 없으신가요?{" "}
            <button
              onClick={() => navigate("/signup")}
              className="text-[#FF7131] hover:text-orange-600 font-semibold"
            >
              회원가입
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
